// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a6fc983e","389":"751b729b","732":"3a232834","857":"1761027e","977":"c4f6108f"}[chunkId] + ".chunk.js";
};